import FilterButton from "common/components/ui/FilterButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";

interface UrlColumnSelectProps {
  urlColumn: string;
  options: string[];
  onSelect: (value: string) => void;
}

export default function UrlColumnSelect({
  urlColumn,
  options,
  onSelect,
}: UrlColumnSelectProps) {
  return (
    <div className="flex items-center gap-x-2.5 px-3 py-2">
      <span className="text-button-xs text-black-500">Identify people by</span>

      <Select value={urlColumn} onValueChange={onSelect}>
        <SelectTrigger asChild>
          <FilterButton className="w-28 lg:w-32" size="sm">
            <SelectValue />
          </FilterButton>
        </SelectTrigger>

        <SelectContent>
          {options.map((option) => (
            <SelectItem value={option} key={option}>
              <SelectItemText>{option}</SelectItemText>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
